import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper } from '@mui/material';

const styles = {
    headerData: {
        padding: "10px",
        textAlign: "left",
        color: "#929497",
        fontSize: "14px",
        fontFamily: "Poppins",
        fontWeight: 700,
    },
    rowData: {
        padding: "10px",
        textAlign: "left",
        color: "#929497",
        fontSize: "14px",
        fontFamily: "Poppins",
        fontWeight: 500,
        borderTop: "1px solid #E7EFFE",
        borderBottom: "1px solid #E7EFFE",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
    },
    pagination: {
        backgroundColor: "#fff", // Prevents background overlap
        boxShadow: "0px -2px 6px rgba(0, 0, 0, 0.06)", // Optional shadow effect for separation
    }
};

const NPOOS_RPOOS_Overlap_Table = ({ tableData = [], searchValue }) => {
    const [filteredTableData, setFilteredTableData] = useState([...tableData]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // console.log("inside NPOOS RPOOS OVERLAP TABLE")

    const formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const options = { day: '2-digit', month: 'short', timeZone: 'UTC' };
        const parts = date.toLocaleDateString('en-GB', options).replace(',', '').split(' ');

        // Manually get last two digits of the year
        const year = date.getUTCFullYear().toString().slice(-2);

        // Join in desired format: '16 Apr 25'
        const formattedDate = `${parts[0]}-${parts[1]}-${year}`;
        return formattedDate;
    };

    useEffect(() => {
        const filteredData = tableData.filter((item) => 
            item?.MaterialID?.toLowerCase()?.includes(searchValue?.toLowerCase()) 
            || item?.Rpoos_Location?.toLowerCase()?.includes(searchValue?.toLowerCase())
        );
        setFilteredTableData(filteredData);
    }, [searchValue, tableData]);

    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to first page when rows per page changes
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: "10px"}}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow >
                            <TableCell style={styles.headerData}>Model Run</TableCell>
                            <TableCell style={styles.headerData}>Material</TableCell>
                            <TableCell style={styles.headerData}>NPOOS Start Date</TableCell>
                            <TableCell style={styles.headerData}>NPOOS End Date</TableCell>
                            <TableCell style={styles.headerData}>NPOOS Cut Quantity</TableCell>
                            <TableCell style={styles.headerData}>RPOOS Start Date</TableCell>
                            <TableCell style={styles.headerData}>RPOOS End Date</TableCell>
                            <TableCell style={styles.headerData}>RPOOS Location</TableCell>
                            <TableCell style={styles.headerData}>RPOOS Cut Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredTableData.length > 0 ? (
                            filteredTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell style={styles.rowData}>{formatDate(row?.ModelRunDate)}</TableCell>
                                    <TableCell style={styles.rowData}>{row?.MaterialID}</TableCell>
                                    <TableCell style={styles.rowData}>{formatDate(row?.Npoos_Start_Date)}</TableCell>
                                    <TableCell style={styles.rowData}>{formatDate(row?.Npoos_End_Date)}</TableCell>
                                    <TableCell style={styles.rowData}>{row?.Npoos_Cut_Quantity?.toFixed(2)}</TableCell>
                                    <TableCell style={styles.rowData}>{formatDate(row?.Rpoos_Start_Date)}</TableCell>
                                    <TableCell style={styles.rowData}>{formatDate(row?.Rpoos_End_Date)}</TableCell>
                                    <TableCell style={styles.rowData}>{row?.Rpoos_Location}</TableCell>
                                    <TableCell style={styles.rowData}>{row?.Rpoos_Cut_Quantity?.toFixed(2)}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan="9"
                                    style={{
                                        textAlign: "center",
                                        color: "#929497",
                                        fontSize: "18px",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        height: "250px",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {searchValue ? "No Records Found" : "No Data Available"}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <div style={styles.pagination}>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={filteredTableData?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </Paper>
    );
};

export default NPOOS_RPOOS_Overlap_Table;
